import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    trafList: [],
};
const getters = {
    getTraf: state => state.trafList

};

const mutations = {
    TRAF_INFO(state, data) {
        state.trafList = data
    }
};

const actions = {
    getTraf({commit}) {
        axiosGet(`crm/traf/status`).then((response) => {
            commit('TRAF_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
